import { LinkedObjects } from "@/mk2/apps/strollers/containers/StrollersDetail/StrollersDetail.actions";
import { APIFailureAction, APIRequestAction, APISuccessAction } from "@/mk2/helpers/action";
import { NormalizedResponse } from "@/mk2/helpers/api";

// Strollers list fetch

export const STROLLERS_LIST_FETCH_TRIGGER = "STROLLERS_LIST_FETCH_TRIGGER";
export interface StrollersFetchTriggerAction {
    readonly type: typeof STROLLERS_LIST_FETCH_TRIGGER;
    readonly slug: string;
    readonly offset: number;
}
export const STROLLERS_LIST_FETCH_REQUEST = "STROLLERS_LIST_FETCH_REQUEST";
export interface StrollersFetchRequestAction extends APIRequestAction {
    readonly type: typeof STROLLERS_LIST_FETCH_REQUEST;
    readonly slug: string;
    readonly offset: number;
}
export interface StrollersFetchNormalizedResponse extends NormalizedResponse {
    readonly result: {
        strollers: number[];
        strollersPreviewPhotoMap: Record<number, number>;
        strollersPhotos: number[];
        brand: number;
        buyingGuide: number;
        counselling: number;
        articles: number[];
    };
}
export const STROLLERS_LIST_FETCH_SUCCESS = "STROLLERS_LIST_FETCH_SUCCESS";
export interface StrollersFetchSuccessAction extends APISuccessAction<StrollersFetchNormalizedResponse> {
    readonly type: typeof STROLLERS_LIST_FETCH_SUCCESS;
    readonly slug: string;
    readonly offset: number;
    readonly hasMore: boolean;
    readonly count: number;
    readonly forumPostLinkedObjects: LinkedObjects;
}

export const STROLLERS_LIST_FETCH_FAILURE = "STROLLERS_LIST_FETCH_FAILURE";
export interface StrollersFetchFailureAction extends APIFailureAction {
    readonly type: typeof STROLLERS_LIST_FETCH_FAILURE;
    readonly slug: string;
    readonly offset: number;
}

export const strollersFetchTrigger = (
    slug: string,
    offset?: number,
): StrollersFetchTriggerAction => ({
    type: STROLLERS_LIST_FETCH_TRIGGER,
    slug,
    offset,
});
export const strollersFetchApi = {
    request: (slug: string, offset: number): StrollersFetchRequestAction => ({
        type: STROLLERS_LIST_FETCH_REQUEST,
        slug,
        offset,
    }),
    success: (
        slug: string,
        offset: number,
        hasMore: boolean,
        count: number,
        forumPostLinkedObjects: LinkedObjects,
        response: StrollersFetchNormalizedResponse,
    ): StrollersFetchSuccessAction => ({
        type: STROLLERS_LIST_FETCH_SUCCESS,
        slug,
        offset,
        hasMore,
        count,
        forumPostLinkedObjects,
        response,
    }),
    failure: (slug: string, offset: number, error: string): StrollersFetchFailureAction => ({
        type: STROLLERS_LIST_FETCH_FAILURE,
        slug,
        offset,
        error,
    }),
};
